import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-record', 'PlayerRecord', [["path",{"d":"M5 12a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}]]);